import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Category } from '../../../models/category/category.model';
import { CategoryService } from '../../../services/category/category.service';
import { UtilitiesService } from '../../../services/shared/utilities.service';
import { BootstrapOptions } from '@angular/core/src/application_ref';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../../services/role/role-permission.service';
@Component({
    selector: 'app-parent-category-list',
    templateUrl: './parent-category-list.component.html',
    styleUrls: ['./parent-category-list.component.css']
})
/** parent-category-list component*/
export class ParentCategoryListComponent {
  public categoryList: Category[];
  public parentCategoryList: Category[];
  public categoryListDropdown: Category[];
  public parentCategoryID: number;
  public isActive: string;
  public searchKeyword: string;
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** parent-category-list ctor */
  constructor(private readonly categoryService: CategoryService,
    private readonly utilitiesService: UtilitiesService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("parentcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (edit.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.GetCategoryList();
          this.GetCategoryListDropdown();
          this.GetParentCategoryList();
          this.GetRowsPerPageList();
          this.parentCategoryID = -1;
            this.isActive = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  GetCategoryList() {
    this.categoryService.GetAllCategoryList().subscribe(
      data => {
        this.categoryList = data;
        this.filteredItems = data;
      }
    )
  }
  GetParentCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data;
      });
  }
  GetCategoryListDropdown() {
    this.categoryService.GetCategoryListUnderParent().subscribe(
      data => {
        this.categoryListDropdown = data;
      });
  }

  deleteCategory(id) {
    var ans = confirm("Are you sure to delete this parent category");
    if (ans) {
      this.categoryService.DeleteCategory(id);
      this.toastr.success('Category deleted successfully.', 'Success');
      setTimeout(() => {
        this.GetCategoryList();
      }, 3000);
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }

  OnFilterChange() {
    this.filteredItems = this.categoryList;

    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.parentCategoryID >= 0) {
      this.filteredItems = this.filteredItems.filter(s => s.parentCategoryID == this.parentCategoryID);
    }
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/parent-category/parent-category-list/parent-category-list.component.ts